import React from 'react';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const formatFileSize = value => {
  const size = Number(value);
  if (!Number.isFinite(size) || size <= 0) {
    return '—';
  }

  if (size < 1024) {
    return `${size} B`;
  }

  if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(1)} KB`;
  }

  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

const formatFileSource = value => {
  if (value === 'system' || value === 'company') {
    return i18next.t(`trainingModuleFiles.sources.${value}`);
  }
  return value || '—';
};

const getTrainingModuleFilesTableConfig = () => [
  {
    title: i18next.t('trainingModuleFiles.source'),
    field: 'source',
    Component: formatFileSource,
  },
  {
    title: i18next.t('trainingModuleFiles.fileName'),
    field: 'name',
  },
  {
    title: i18next.t('trainingModuleFiles.fileSize'),
    field: 'documentSize',
    Component: formatFileSize,
  },
  {
    title: i18next.t('trainingModuleFiles.uploadedBy'),
    field: 'uploadedByName',
    Component: value => value || '—',
  },
  {
    title: i18next.t('tablesLabels.uploadDate'),
    field: 'createdAt',
    Component: value => <DateFormatter value={value} format="MM/DD/YYYY LT" />,
  },
  {
    title: '',
    field: 'id',
    isVisible: false,
  },
];

export default getTrainingModuleFilesTableConfig;
